module.exports = __webpack_public_path__ + "images/show-off-b7f01a66fef94e2c11f47bfd51f35caa.png";